import { useTranslation } from 'react-i18next';

import { Wrapper, EmojiWrapper, Title, Description, TextWrapper } from './EmptyQuizzes.styles';

export const EmptyQuizzes: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');

  return (
    <Wrapper>
      <EmojiWrapper>
        <span role="img" aria-label="target">
          🎯
        </span>
      </EmojiWrapper>
      <TextWrapper>
        <Title>{t('EMPTY_QUIZZES_TITLE')}</Title>
        <Description>{t('EMPTY_QUIZZES_DESCRIPTION')}</Description>
      </TextWrapper>
    </Wrapper>
  );
};
